import React, { useState } from "react";
import Slider from "../slider/Slider";

import "./ProjectCard.scss";

const ProjectCard = (props) => {
  const { projectName, projectTags, images } = props;
  const listTags = projectTags.map((tag, idx) => (
    <li key={idx} className="tag">
      {tag}
    </li>
  ));

  const [openCard, setOpenCard] = useState(false);

  const handleOpenCard = () => {
    setOpenCard(!openCard);
  };

  return (
    <Slider images={images} onClick={handleOpenCard}>
      <div
        onClick={handleOpenCard}
        className={`project-text ${openCard ? "project-text--open" : ""}`}
      >
        <p className="project-name">{projectName}</p>
        <ul className="tags">{listTags}</ul>
        <p className="description">{props.children}</p>
      </div>
    </Slider>
  );
};

export default ProjectCard;
